// extracted by mini-css-extract-plugin
module.exports = {"typingAvatar":"widget-space--typingAvatar--29Ojd","avatar":"widget-space--avatar--3g98r"};